<template>
  <div
    id="diplomaPage1MB"
    style="width: 29.7cm; height: 21cm; border: 1px solid black"
    class="mx-16"
  >
    <Page1MBHelper
      class="mx-auto"
      :student="student"
      :selectedMBCard="selectedMBCard"
    ></Page1MBHelper>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Page1MBHelper from "./Page1MBHelper.vue";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    ui_setting_page2: {},
  }),
  watch: {},
  props: {
    student: {
      required: true,
      type: Object,
    },
    selectedMBCard: {
      type: Object,
    },
  },
  components: {
    Page1MBHelper,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page2")
      .onSnapshot((doc) => {
        this.ui_setting_page2 = doc.data();
        this.ui_setting_page2.ref = doc.ref;
        this.ui_setting_page2.id = doc.id;
        console.log(this.ui_setting_page2);
      });
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-mb")
      .onSnapshot((doc) => {
        this.ui_setting_page2mb = doc.data();
        this.ui_setting_page2mb.ref = doc.ref;
        this.ui_setting_page2mb.id = doc.id;
        console.log(this.ui_setting_page2mb);
      });
  },
  mounted() {
    this.nochange = true;
  },

  methods: {},
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>
